module.exports = __webpack_public_path__ + "static/media/home-preview-feed.051a1828.png";